import React from 'react';
import { BookingPurchaseDialog } from './BookingPurchaseDialog';
import type { BuyMembershipHostData } from './buyMembership.types';
import { useBuyMembershipDialog } from './useBuyMembershipDialog';

type Props = Readonly<{
  data: BuyMembershipHostData;
}>;

export function BuyMembershipDialog({ data }: Props) {
  const dialogData = useBuyMembershipDialog(data);

  return <BookingPurchaseDialog data={dialogData} />;
}
